import * as apiSW from 'api/season/GetSeasonStartingWithV1';
import { Selectable } from 'classes/_general/Search/MultiSelect';
import Season from 'classes/_general/Search/Season/Season';
import { ISelectItem } from 'interfaces/ISelectItem';

export default class SeasonList implements Selectable {
	public all: Season[] = [];
	public filtered: ISelectItem[] = [];

	public async initialize(): Promise<void> {
		const response = await apiSW.callApi('', false);
		response.hasValue() && this.mapFromApi(response.get());
	}

	public async search(searchTerm: string): Promise<void> {
		const filtered: Season[] = this.all.filter((e: Season) =>
			e.name.toLowerCase().startsWith(searchTerm.toLowerCase())
		);
		this.filtered = this.mapToSelectItems(filtered);
	}

	public getById(id: string): Season | undefined {
		return this.all.find((e: Season) => {
			return e.id === id;
		});
	}

	private mapToSelectItems(input: Season[]): ISelectItem[] {
		return input.map((e: Season) => {
			return e.toSelectItem();
		});
	}

	private mapFromApi(input: apiSW.ResponseSeason[]): void {
		this.all = [];
		for (const i of input) {
			const season: Season = new Season(i);
			this.all.push(season);
		}
	}
}
